import Section from '../../../elements/Section'
import Container from '../../../elements/Container'
import Columns from '../../../layout/Columns'
import Column from '../../../layout/Column'
import styles from './styles.module.scss'
import Perk from '../../single-property/components/Perk'
import { useResponsive } from '../../../../providers/ResponsiveContext'

// to be moved to a common component with welcome page
const Summary = ({ statistics, label, title, description }) => {
  const { isMobile, isTablet } = useResponsive()

  return (
    <Section className={styles.section} variant={['gray']}>
      <Container>
        <Columns variant={['-distribute-around', '-align-middle']}>
          <Column spans={isMobile ? 12 : isTablet ? 7 : 6}>
            {label && <span className={styles.label}>{label}</span>}

            {title && (
              <h2
                dangerouslySetInnerHTML={{ __html: title }}
                className={styles.title}
              ></h2>
            )}

            <div className={styles.description}>
              <div className={styles.divider}></div>

              {description && (
                <div>
                  <p dangerouslySetInnerHTML={{ __html: description }}></p>
                </div>
              )}
            </div>
          </Column>
          <Column spans={isMobile ? 12 : 5}>
            {statistics && (
              <div className={styles.perks}>
                {statistics.map((item, index) => (
                  <Perk
                    variant={['large']}
                    key={index}
                    {...item}
                    icon={item.cloudflare_icon}
                    title={item.title}
                  />
                ))}
              </div>
            )}
          </Column>
        </Columns>
      </Container>
    </Section>
  )
}

export default Summary
